<template>
	<ListDetailLayout
			:store="teamsStore"
      index-route-name="admin.users.teams"
			create-permissions="create:teams"
			@on-create="$router.push({ name: 'admin.users.teams.team', params: { team: 'NEW' } })"
			@on-paginate="(page) => useOnPaginate(page, refreshTeams, params)"
			@on-search="(page) => useOnSearch(page, refreshTeams, params)"
	>

		<template #list>
			<li v-for="team in teamsStore.getTeams" :key="team.id">
				<router-link :to="{ name: 'admin.users.teams.team', params: { team: team.id } }" v-slot="{isActive}">
					<div :class="[isActive ? 'border-primary-500 dark:bg-surface-600' : 'border-transparent hover:bg-surface-50 dark:hover:bg-surface-800', 'transition-colors border-l-4 flex items-center justify-between gap-x-6 py-5 pl-3 pr-4 bg-surface-0 dark:bg-surface-800']">

						<div class="min-w-0">
							<div class="flex items-start gap-x-3">
								<p class="text-sm font-semibold leading-6 text-surface-900 dark:text-surface-200">{{ team.display_name }}</p>
							</div>
							<div class="mt-1 flex items-center gap-x-2 text-xs leading-5 text-surface-500 dark:text-surface-400">
								<p class="whitespace-nowrap">
									{{ team.name }}
								</p>
							</div>
						</div>

					</div>
				</router-link>
			</li>
		</template>

		<template #detail>
				<router-view v-if="$route.params.team" @on-save="refreshTeams" @on-delete="refreshTeams"></router-view>
		</template>

	</ListDetailLayout>
</template>

<script>
import ListDetailLayout from "@/Layouts/ListDetailLayout.vue";
import Container from "@/Components/Container.vue";
import { mapStores } from "pinia";
import { useTeamsStore } from "@/stores/teams.js";
import { useOnPaginate, useOnSearch } from "@/Composables/Pagination.js";

export default {
	name: "TeamsIndex",
	data() {
		return {
			params: {}
		}
	},
	methods: {
		useOnSearch,
		useOnPaginate,
		refreshTeams(){
			return this.teamsStore.indexTeams(this.params);
		},
	},
	components: {Container, ListDetailLayout},
	computed: {
		...mapStores(useTeamsStore)
	},
	async mounted() {
		await this.refreshTeams()
	}
}
</script>